import { useLocation } from 'react-router-dom'
const guides: Record<string, [string, string, string]> = {
  public: [
    'Публичные портфели: разбор чужой стратегии',
    'Выберите портфель, изучите состав и условия расчёта. Публичные данные предоставлены владельцем и не являются подтверждением доходности.',
    'В портфеле 60% облигаций и 40% акций. Это распределение, а не совет повторить сделки. У вас могут отличаться горизонт и расходы.',
  ],
  p: [
    'Разбор портфеля',
    'Смотрите состав, валюту, даты и настройки приватности. Скрытые суммы нельзя восстановить из процентной доходности.',
    'Рост стоимости на 20% мог быть результатом пополнения. Для проверки попросите полную историю внешних переводов и оценок.',
  ],
  pricing: [
    'Тарифы: выберите нужный объём учёта',
    'Проверьте период оплаты, стоимость и ограничения выбранного плана. Кнопка выбора открывает оформление подписки.',
    'При оплате за год сравнивайте полную годовую сумму, а не только эквивалент за месяц. Продление отменяется в настройках подписки.',
  ],
  portfolios: [
    'Портфели: отдельные счета и стратегии',
    'Создайте портфель, затем добавьте сделки или загрузите брокерский отчёт. Откройте карточку для состава и операций.',
    '«Т-Инвестиции» и «ИИС» — два портфеля. На главной они учитываются вместе. Не заносите одну позицию дважды.',
  ],
  transactions: [
    'Операции: что и когда произошло',
    'Выберите портфель, тип операции, актив, количество, цену и дату. Комиссия и налог вводятся отдельно.',
    '10 акций по 300 ₽ — покупка на 3 000 ₽. Покупка внутри счёта не равна пополнению счёта.',
  ],
  import: [
    'Импорт: начните с отчёта брокера',
    'Выберите портфель и брокера, загрузите файл в указанном формате. Проверьте результат импорта и предупреждения до повторной загрузки.',
    'Для полной истории нужен отчёт с первой сделки, а не скриншот текущего баланса. Не дублируйте уже введённые операции.',
  ],
  realestate: [
    'Недвижимость: объект, аренда и ипотека',
    'Добавьте объект, свою оценку, условия аренды и расходы. Остаток ипотеки уменьшает капитал, платёж — деньги на руки.',
    'Аренда 65 000 ₽ − расходы 10 000 ₽ − налог 4 000 ₽ − ипотека 25 000 ₽ = 26 000 ₽ в месяц. Простои учитывайте в плане.',
  ],
  'other-assets': [
    'Бизнес, золото и другие активы',
    'Выберите категорию и введите стоимость своей доли. Доходы по месяцам добавляются отдельно. Быстрые записи с главной редактируйте на главной.',
    '40% бизнеса стоимостью 10 млн ₽ — актив на 4 млн ₽. Выручка компании не является вашим личным доходом.',
  ],
  captables: [
    'Доли и опционы: кто чем владеет',
    'Создайте компанию, добавьте участников, раунды и права на доли. Это структура всей компании, а не сумма вашего капитала.',
    '10 000 акций из 100 000 — доля 10%. Опцион становится акциями после выполнения условий и исполнения; цена исполнения уменьшает результат.',
  ],
  pipelines: [
    'Воронка сделок: от идеи до решения',
    'Создайте воронку и этапы, затем добавляйте сделки. Перемещение карточки меняет этап рассмотрения, но не создаёт актив.',
    '«Идея → проверка → переговоры → решение». Покупка склада в переговорах ещё не входит в ваш капитал.',
  ],
  tax: [
    'Налоги: предварительный расчёт',
    'Выберите портфель и период, проверьте исходные продажи, стоимость покупок и удержания. Результат нужно сверять с документами брокера.',
    'При продаже за 110 000 ₽ и расходах на покупку 100 000 ₽ прибыль до дополнительных расходов — 10 000 ₽. Налог зависит от режима и льгот.',
  ],
  dividends: [
    'Календарь: ожидаемые и полученные выплаты',
    'Выберите портфель и период. Отличайте объявленные выплаты, прогнозы и фактически полученные деньги.',
    'Дата отсечки определяет право на дивиденд. Деньги поступают позже; прогноз в календаре ещё не означает оплату.',
  ],
  screener: [
    'Скринер: отбор бумаг по условиям',
    'Задайте фильтры и сравните найденные бумаги. Метрики помогают сузить поиск, но не определяют подходящую вам покупку.',
    'Высокая дивидендная доходность может означать падение цены. Проверьте дату данных, устойчивость выплат и долг компании.',
  ],
  community: [
    'Сообщество: идеи и разборы',
    'Откройте материал, изучите исходные данные и обсудите выводы в комментариях. Для публикации добавьте понятное описание и источник цифр.',
    'Разбор «квартира или ОФЗ» сравнивает один период, вложения, расходы, налоги и риски. Один процент без этих условий мало о чём говорит.',
  ],
  settings: [
    'Настройки: профиль, подписка и оформление',
    'На вкладке подписки доступны статус оплаты и отмена продления. Тема и язык переключаются сразу. Недоступные функции отмечены явно.',
    'Отмена продления оставляет доступ до конца оплаченного периода; это не удаление аккаунта или портфелей.',
  ],
  exchange: [
    'Биржевой обзор: один выбранный портфель',
    'Этот раздел показывает учёт биржевых позиций. Для общей картины имущества и долгов используйте «Мой капитал».',
    'Стоимость позиции 110 000 ₽ при покупке за 100 000 ₽ — рост цены 10 000 ₽, а не полная доходность с выплатами и налогами.',
  ],
  admin: [
    'Администрирование: доступ и владельцы',
    'Изменения здесь влияют на других пользователей. Перед переносом портфеля проверьте его название и нового владельца.',
    'Перенос портфеля меняет пользователя, которому доступны его активы. Это не публикация портфеля.',
  ],
}
export function FeatureGuide() {
  const { pathname } = useLocation()
  const guide = guides[pathname.split('/')[1]]
  if (!guide) return null
  return (
    <details className="wealth-guide" key={pathname}>
      <summary>Как пользоваться · {guide[0]}</summary>
      <p>{guide[1]}</p>
      <p>
        <strong>Пример.</strong> {guide[2]}
      </p>
    </details>
  )
}
